import type { MouseEvent, RefObject } from 'react';
import { useCallback } from 'react';
import { useOpenContextMenu } from '@frameio/shared/contexts';

export type WorkspaceProjectTarget =
  | {
      id: string;
      type: 'project';
    }
  | {
      id: string;
      type: 'workspace';
    }
  | null;

export const useOpenWorkspaceProjectMenu = () => {
  const openContextMenu = useOpenContextMenu<
    WorkspaceProjectTarget,
    HTMLDivElement | HTMLButtonElement
  >();

  return useCallback(
    (
      target: WorkspaceProjectTarget,
      el: RefObject<HTMLDivElement | HTMLButtonElement | null> | null,
      event?: MouseEvent | null
    ) => {
      openContextMenu(target, el?.current || null, event);
    },
    [openContextMenu]
  );
};
